import React from 'react'
import { Suspense } from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { lazy } from 'react'
import Spinner from 'components/loaders/Spinner'
import { TitleNameProvider } from 'context/TitleNameContext'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { unregister } from './registerServiceWorker'
import { MIXPANEL_TOKEN } from 'config/api'
import mixpanel from 'mixpanel-browser'

// import { Provider } from 'react-redux';
// import store from "./store/store";
import './index.css'

mixpanel.init(MIXPANEL_TOKEN, 
{
  debug: true,
  autocapture: true,
  track_pageview: true,
  persistence: 'localStorage',
  record_sessions_percent: 100,
})

unregister();

const App = lazy(() => import('./App'))
// test
ReactDOM.render(
  <React.StrictMode>
    {/* // <Provider store={store}> */}
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="mx-auto max-w-[430px] h-screen flex items-center justify-center">
            <Spinner color="#C41230" />
          </div>
        }
      >
        <TitleNameProvider>
          <App />
        </TitleNameProvider>
      </Suspense>
    </BrowserRouter>
    {/* // </Provider> */}
  </React.StrictMode>
  ,
  document.getElementById('root')
)
serviceWorkerRegistration.register()
reportWebVitals()
